module.exports = __webpack_public_path__ + "img/news-default.7d1698a7.png";